// Uncover Gift — registry dei 5 tier (2D + parametri scena 3D).
// Estendibile: aggiungi una entry e animazioni/box/colori si propagano in tutta la UI.

export const TIER_ORDER = ["common", "rare", "epic", "legendary", "mythic"];

export const TIERS = {
  common: {
    label: "Common",
    accent: "#B8C1CC",
    accent2: "#7C8794",
    glow: "rgba(184,193,204,0.55)",
    bg: "radial-gradient(circle at 50% 55%, #1b2027 0%, #0a0c10 70%)",
    particles: 14, rings: 1, rays: 0, rain: 0, shake: 0,
    duration: 2000,
    // 3D
    sceneBg: "#080a0d",
    boxColor: "#4a525e",
    trimColor: "#cfd6de",
    lightA: "#aab4c0",
    lightB: "#5c6673",
    bloom: 0.3,
    shards: 26,
    dust: 220,
    beams: 6,
    shakeAmp: 0.02,
    rank: 0,
  },
  rare: {
    label: "Rare",
    accent: "#4FD1FF",
    accent2: "#1E6BFF",
    glow: "rgba(79,209,255,0.6)",
    bg: "radial-gradient(circle at 50% 55%, #0a2b3d 0%, #05080f 72%)",
    particles: 26, rings: 2, rays: 6, rain: 0, shake: 0,
    duration: 3200,
    sceneBg: "#03080f",
    boxColor: "#123a52",
    trimColor: "#7fe4ff",
    lightA: "#4FD1FF",
    lightB: "#1E6BFF",
    bloom: 0.45,
    shards: 40,
    dust: 320,
    beams: 10,
    shakeAmp: 0.035,
    rank: 1,
  },
  epic: {
    label: "Epic",
    accent: "#C77DFF",
    accent2: "#7B2CFF",
    glow: "rgba(199,125,255,0.65)",
    bg: "radial-gradient(circle at 50% 50%, #2a0f4d 0%, #07050f 72%)",
    particles: 40, rings: 3, rays: 12, rain: 18, shake: 1,
    duration: 4500,
    sceneBg: "#07030f",
    boxColor: "#2b1150",
    trimColor: "#d9a8ff",
    lightA: "#C77DFF",
    lightB: "#7B2CFF",
    bloom: 0.62,
    shards: 56,
    dust: 420,
    beams: 14,
    shakeAmp: 0.055,
    rank: 2,
  },
  legendary: {
    label: "Legendary",
    accent: "#FFD166",
    accent2: "#FF8A00",
    glow: "rgba(255,209,102,0.7)",
    bg: "radial-gradient(circle at 50% 50%, #3d2606 0%, #0a0703 74%)",
    particles: 60, rings: 4, rays: 18, rain: 34, shake: 2,
    duration: 6000,
    sceneBg: "#0a0602",
    boxColor: "#4a2f06",
    trimColor: "#ffe6a3",
    lightA: "#FFD166",
    lightB: "#FF8A00",
    bloom: 0.82,
    shards: 72,
    dust: 520,
    beams: 20,
    shakeAmp: 0.08,
    rank: 3,
  },
  mythic: {
    label: "Mythic",
    accent: "#FF4D6D",
    accent2: "#FFD166",
    glow: "rgba(255,77,109,0.75)",
    bg: "radial-gradient(circle at 50% 50%, #4a0620 0%, #06010a 76%)",
    particles: 90, rings: 5, rays: 24, rain: 52, shake: 3,
    prismatic: true,
    duration: 8000,
    sceneBg: "#0b0208",
    boxColor: "#54061f",
    trimColor: "#ffd9e2",
    lightA: "#FF4D6D",
    lightB: "#FFD166",
    bloom: 1.05,
    shards: 96,
    dust: 680,
    beams: 26,
    shakeAmp: 0.11,
    prismaticScene: true,
    rank: 4,
  },
};

export const getTier = (tier) => TIERS[tier] || TIERS.common;
